import { AgentLayerRow } from "@/components/layout/AgentLayerRow";
import { AiWidget } from "@/components/layout/AiWidget";
import { AppTopBar } from "@/components/layout/AppTopBar";
import { BottomTabNav } from "@/components/layout/BottomTabNav";
import { CommandPalette } from "@/components/layout/CommandPalette";
import { DemoNetworkBanner } from "@/components/layout/DemoNetworkBanner";
import { EnvDiagnosticsBanner } from "@/components/layout/EnvDiagnosticsBanner";
import { GasStatusRow } from "@/components/layout/GasStatusRow";
import { OraclePriceBand } from "@/components/layout/OraclePriceBand";
import { PrimaryNavRow } from "@/components/layout/PrimaryNavRow";
import { ProtocolStatusRow } from "@/components/layout/ProtocolStatusRow";
import { AmbientField } from "@/components/layout/AmbientField";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { networkLabel } from "@/lib/network";
import { useState } from "react";
import { Outlet } from "react-router-dom";

export function AppShell() {
	const [commandOpen, setCommandOpen] = useState(false);
	const net = networkLabel();
	const showSandbox = net === "play" || net === "local";

	return (
		<div className="site-shell relative min-h-screen min-h-dvh">
			<AmbientField />

			<div className="app-shell-content">
				<div className="sticky top-0 z-40">
					<OraclePriceBand />
					<EnvDiagnosticsBanner />
					<AppTopBar onOpenCommand={() => setCommandOpen(true)} />
					<PrimaryNavRow />
				</div>
				<a
					href="#main-content"
					className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-primary focus:px-3 focus:py-1 focus:text-primary-foreground"
				>
					Skip to main content
				</a>
				<main id="main-content" className="app-main min-w-0 flex-1">
					<Outlet />
				</main>

				{/*
				  Mobile: tabs (~3.25rem) + soft soft strip (~1.5rem) + safe-area
				  Desktop: agent band + full play banner
				*/}
				<div
					className={
						showSandbox
							? "mt-auto border-t border-border pb-[calc(5rem+env(safe-area-inset-bottom))] md:pb-[var(--bottom-chrome-h,7.5rem)]"
							: "mt-auto border-t border-border pb-[calc(4.25rem+env(safe-area-inset-bottom))] md:pb-[var(--bottom-chrome-h,3.5rem)]"
					}
				>
					<ProtocolStatusRow />
					<GasStatusRow />
					<SiteFooter />
				</div>
			</div>

			{/* Desktop only: Agent Layer + full solid Play/local banner under it */}
			<div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 hidden flex-col md:flex">
				<div className="pointer-events-auto">
					<AgentLayerRow className="!static !inset-auto" />
				</div>
				{showSandbox ? (
					<div className="pointer-events-auto">
						<DemoNetworkBanner compact variant="full" />
					</div>
				) : null}
			</div>

			{/* Mobile: tabs + soft sandbox under tabs (inside BottomTabNav) */}
			<BottomTabNav />
			<AiWidget />
			<CommandPalette open={commandOpen} onOpenChange={setCommandOpen} />
		</div>
	);
}
